import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {ApiService} from './api.service';
import {Response} from 'src/app/shared/models/response.model';

const API_CHECK_DELETE_RELATION = "/master-data/check-delete-relation/";
const API_GET_ALL_ITEMS = "/master-data/get-all/"

@Injectable({
  providedIn: 'root'
})
export class MasterDataService {

  constructor(private apiService: ApiService) { }

  getItem(body: any = {}): Observable<any> {
    return this.apiService.post(API_GET_ALL_ITEMS, body).pipe(
      map((res) => {
        return res;
      })
    );
  }

  checkDeleteRelation(id: string): Observable<Response<any>> {
    return this.apiService.get(`${API_CHECK_DELETE_RELATION}${id}`).pipe(
      map((res) => {
        return res;
      })
    );
  }
}
